import React, { Component } from 'react'
import PropTypes from 'prop-types'

import CampaignQuotesWrapper from 'agency/digital_renderer/components/CampaignQuotesWrapper'

import ContentHolder from '../../ui/ContentHolder'
import Quote from './Quote'
import styles from './styles.scss'

class CampaignQuotes extends Component {
  _renderQuoteToggle = (params) => {
    const { campaignQuotes, selectedQuoteId, selectQuoteId } = params
    if (!campaignQuotes.length) return null

    return (
      <ul className={styles.quoteToggle}>
        {campaignQuotes.map(quote => (
          <li key={quote.id}>
            <a
              className={quote.id === selectedQuoteId ? styles.selected : null}
              tabIndex="0"
              onClick={() => selectQuoteId(quote.id)}
            >
              {quote.title}
            </a>
          </li>
        ))}
      </ul>
    )
  }

  _renderQuote = (params) => {
    const { campaignQuote } = params
    return <Quote campaignQuote={campaignQuote} />
  }

  _renderContent = params => (
    <div className={styles.root}>
      <ContentHolder>
        <div className={styles.header}>
          <h3>Marketing schedule</h3>
          <p>
            The Agency utilises service offerings by the best real estate marketing companies in the country to promote
            your property and highlight it against competing homes.
          </p>
        </div>
      </ContentHolder>

      <ContentHolder>{this._renderQuoteToggle(params)}</ContentHolder>

      {this._renderQuote(params)}
    </div>
  )

  render(){
    const { campaignProposal } = this.props

    return <CampaignQuotesWrapper dataSource={campaignProposal} render={params => this._renderContent(params)} />
  }
}

CampaignQuotes.propTypes = {
  campaignProposal: PropTypes.object.isRequired,
}

export default CampaignQuotes
